import { doLogin, doLogout, getUserProfile, changeUserPassword } from '@/services/AuthService'
import * as types from '../mutations'

const state = {
  isLoggedin: false,
  authToken: '',
  profile: {}
}

const getters = {
  authToken: (state) => state.authToken,
  isLoggedin: (state) => state.isLoggedin,
  profile: (state) => state.profile
}

const actions = {

  async login ({ commit, dispatch }, { email, password }) {
    let token = await doLogin({ email, password })
    if (token) {
      commit(types.LOGIN)
      dispatch('setAuthToken', { token: token })
    } else {

    }
  },

  async changePassword ({ commit }, form) {
    await changeUserPassword(form)
  },

  async getUserProfile ({ commit }) {
    let profile = await getUserProfile()
    commit(types.SET_USER_PROFILE, profile)
  },

  logout ({ commit }) {
    doLogout()
    commit(types.LOGOUT)
  },

  setAuthToken ({ commit }, { token }) {
    commit(types.SET_AUTH_TOKEN, token)
    if (token) {
      commit(types.LOGIN)
    }
  }
}

const mutations = {

  [types.SET_AUTH_TOKEN] (state, token) {
    state.authToken = token
  },

  [types.LOGIN] (state) {
    state.isLoggedin = true
  },

  [types.LOGOUT] (state) {
    state.isLoggedin = false
    state.authToken = ''
  },

  [types.SET_USER_PROFILE] (state, profile) {
    state.profile = profile
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
